<template>
      <q-select :style="{width: width + 'px'}"
        dense rounded outlined 

        ref="esaSppSelect"
        :options="esaSppOptions" 
        :label="label" 

        @input="spSelect"
        :color="color"
        v-model="currSp"
      >
        <template v-slot:option="scope">
          <q-item
            v-if="scope.opt.header"
            :key="'header-' + scope.index"
            class="q-pa-none"
          >
            <q-item-section>
              <q-item-label header class="header-style">{{ scope.opt.label }}</q-item-label>
            </q-item-section>
          </q-item>
          <q-item
            v-else
            :key="'option-' + scope.index"
            clickable
            @click="spSelect(scope.opt)"
          >
            <q-item-section>
              <q-item-label >{{ scope.opt.label }}</q-item-label>
            </q-item-section>
          </q-item>
        </template>
      </q-select>
</template>
<script setup lang="ts">
import { ref, toRefs, computed } from "vue";
import { useRouter } from 'vue-router';
import { useMapItems } from "../composables/useMapItems"
import { useHelpers } from "@/composables/useHelpers";
const props = defineProps({
    width: {type: Number, default:260},
    label: {type: String, default: "Spotlight a Species"},
    color: {type: String, default: "black"},
    hint: {type: Boolean, default: true}
})
const { width, label, color } = toRefs(props)
const router = useRouter();
const { setActiveSpSpotlight, setProcessedData, clearMapStyle, activeSpSpotlight } = useMapItems()
const { logGAevent, arrayFindObjectByProp } = useHelpers()

const currSp = computed({
  get() {
    if (activeSpSpotlight.value){
      return arrayFindObjectByProp(esaSppOptions.value, "value", activeSpSpotlight.value);
    }
    else{
      return null
    }

    
  },
  set(value) {
    // console.log(value)
    
    // setActiveSpSpotlight(value);
  }
});

const esaSpp = ref(null)
const esaSppOptions = ref([
  {header: true, label: 'Birds'},
  {value: "AMOY", label:"American Oystercatcher"},
  {value: "ARTE", label:"Arctic Tern"},
  {value: "ATPU", label:"Atlantic Puffin"},
  {value: "AUSH", label:"Audubon Shearwater"},
  {value: "BCPE", label:"Black Capped Petrel"},
  {value: "BLSK", label:"Black Skimmer"},
  {value: "BLTE", label:"Black Tern"},
  {value: "COEI", label:"Common Eider"},
  {value: "COLO", label:"Common Loon"},
  {value: "COMU", label:"Common Murre"},
  {value: "COTE", label:"Common Tern"},
  {value: "EAME", label:"Eastern Meadowlark"},
  {value: "FOTE", label:"Forsters Tern"},
  {value: "GBTE", label:"Gull-billed Tern"},
  {value: "GRCO", label:"Great Cormorant"},
  {value: "HADU", label:"Harlequin Duck"},
  {value: "LEBI", label:"Least Bittern"},
  {value: "LETE", label:"Least Tern"},
  {value: "LTDU", label:"Long Tailed Duck"},
  {value: "NOGA", label:"Northern Gannet"},
  {value: "PIPL", label:"Piping Plover"},
  {value: "PUSA", label:"Purple Sandpiper"},
  {value: "RAZO", label:"Razorbill"},
  {value: "REKN", label:"Red Knot"},
  {value: "ROST", label:"Roseate Tern"},
  {value: "ROYT", label:"Royal Tern"},
  {value: "SASP", label:"Saltmarsh Sparrow"},
  {value: "WIPL", label:"Wilsons Plover"},
  {value: "WWSC", label:"White-Winged Scoter"}
  // {label: "Roseate Tern", value: "ROST"},
  // {label: "Arctic Tern", value: "ARTE"},
  // {label: "Black Scoter", value: "BLSC"},
  // {label: "Black Tern", value: "BLTE"},
  // {label: "Bonaparte's Gull", value: "BOGU"},
  // {label: "Common Eider", value: "COEI"},
  // {label: "Common Loon", value: "COLO"},
  // {label: "Common Tern", value: "COTE"},
  // {label: "Forster's Tern", value: "FOTE"},
  // {label: "Horned Grebe", value: "HOGR"},
  // {label: "Least Tern", value: "LETE"},
  // {label: "Long-tailed Duck", value: "LTDU"},
  // {label: "Red-necked Phalarope", value: "RNPH"},

  // {header: true, label: 'Mammals'},
  // {label: "North Atlantic Right Whale", value: "RIWH"},
  // {label: "Fin Whale", value: "FIWH"},
  // {label: "Blue Whale", value: "BLWH"},
  // {label: "Sei Whale", value: "SEWH"},
  // {header: true, label: 'Fish'},
  // {label: "Atlantic Sturgeon", value: "SP380"},
  // {header: true, label: 'Turtles'},
  // {label: "Green sea turtle", value: "GRTU"},      
  // {label: "Kemp's ridley sea turtle", value: "KRTU"},  
  // {label: "Leatherback sea turtle", value: "LETU"},  
  // {label: "Loggerhead sea turtle", value: "LOTU"},  
])
const esaSppSelect = ref(null);
const spSelect = (opt) =>{
  logGAevent('sp_spotlight', opt.value, "")
  clearMapStyle()
  // console.log(opt.value)
  esaSpp.value = opt;
  esaSppSelect.value.hidePopup();
  setActiveSpSpotlight(opt.value)
  router.push({
    path:'/spSpotlight'
  })
  setProcessedData('spSpotlight', opt.value)
}
</script>
<style>
.header-style {
  font-weight: bold;
  font-size: 1.2em;
  text-decoration: underline;
  color: #000000;
  background-color: #e0e0e0;
  padding: 8px;
}</style>